/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { ETransportUniqueResource } from './etransport-unique-resource';

export class ETransportShipmentDocumentDTO extends ETransportUniqueResource {
  uuid: string | null = null;
  documentTypeUuid: string | null = null;
  documentNumber: string | null = null;
  documentDate: string | null = null;
  observations: string | null = null;
}
